<template>
  <div
    class="container-fluid mycontainer-fluid content contacts"
    v-if="$parent.rerender"
    style="padding-top: 20px"
  >
    <div
      v-if="
        currentUser.ACTIVE_ROLE_CODE !== 'lizing' ||
          (currentUser.ACTIVE_ROLE_CODE === 'lizing' && project.ORG_INFO.ID > 0)
      "
    >
      <!--   начало блока подсказок   -->
      <div
        class="org-box screenplay-container"
        id="screenplay-etap-1-6"
        :class="[project.BLOCK_ORG ? 'active' : '']"
        ref="BLOCK_ORG"
      >
        <FirstScenariosStep
          :project="project"
          step-name="BLOCK_ORG"
          custom-class="stl-lb-box"
        />
        <div class="org-box-title">организация</div>
        <div class="org-name">{{ project.ORG_INFO.UF_FULLNAME }}</div>
        <div class="org-box-body">
          <div class="row myrow org-box-body-tr">
            <div class="col-xs-4 col-sm-4 col-md-4">ОГРН</div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              {{ project.ORG_INFO.UF_OGRN }}
            </div>
          </div>
          <div class="row myrow org-box-body-tr">
            <div class="col-xs-4 col-sm-4 col-md-4">ИНН/КПП</div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              {{ project.ORG_INFO.UF_INN }}/{{ project.ORG_INFO.UF_KPP }}
            </div>
          </div>
          <div class="row myrow org-box-body-tr">
            <div class="col-xs-4 col-sm-4 col-md-4">Год гос.регистрации</div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              {{ project.ORG_INFO.UF_DATE_REGISTER }}
            </div>
          </div>
          <div class="row myrow org-box-body-tr">
            <div class="col-xs-4 col-sm-4 col-md-4">
              <span>{{ project.ORG_INFO.UF_DIR_POSITION }}</span>
              <button
                type="button"
                class="btn-snails"
                @click="showSnilsUploader = true"
                v-if="
                  !project.ORG_INFO.UF_SNILS_FILE &&
                    $parent.isEditProject &&
                    isEditContacts &&
                    stConf.IS_DOWNLOAD_SNILS
                "
              >
                <b>Загрузить</b>
                <span>СНИЛС</span>
              </button>
              <b
                class="s-proverka"
                v-if="
                  project.ORG_INFO.UF_SNILS_FILE > 0 &&
                    !project.ORG_INFO.UF_SNILS
                "
                >СНИЛС на проверке</b
              >
              <b class="s-active1" v-else-if="project.ORG_INFO.UF_SNILS"
                >СНИЛС введен</b
              >
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              {{ project.ORG_INFO.UF_DIR_LAST_NAME }}
              {{ project.ORG_INFO.UF_DIR_NAME }}
              {{ project.ORG_INFO.UF_DIR_SECOND_NAME }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="org-box screenplay-container"
        :class="[project.BLOCK_ORG_ADRESS ? 'active' : '']"
        id="screenplay-etap-1-7"
        ref="BLOCK_ORG_ADRESS"
      >
        <FirstScenariosStep
          :project="project"
          step-name="BLOCK_ORG_ADRESS"
          custom-class="stl-lt-box"
        />
        <div class="org-box-title">
          адреса организации
          <i
            class="i-plus"
            @click="createAddress"
            v-if="aAddress().length > 0 && $parent.isEditProject"
          ></i>
        </div>
        <div class="adress-box-body">
          <div class="row myrow adress-box-body-row">
            <div class="col-xs-4 col-sm-4 col-md-4">
              <b>Веб-сайт</b>
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              <b>
                <a :href="'http://' + project.ORG_INFO.UF_WEB_SITE">{{
                  project.ORG_INFO.UF_WEB_SITE
                }}</a>
              </b>
              <i
                class="i-edit"
                @click="makeSiteDialog()"
                v-if="$parent.isEditProject && isEditContacts"
              ></i>
            </div>
          </div>
          <div
            class="row myrow adress-box-body-row"
            v-for="(address, index) in project.ORG_INFO.ADDRESS"
          >
            <div class="col-xs-4 col-sm-4 col-md-4">
              {{ getAddressType(address.UF_TYPE_ADDR_ID) }}
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 text-right">
              {{ address.UF_POST_INDEX }},
              {{ getRegion(address.UF_REGION_ID) }}, {{ address.UF_CITY }},
              {{ address.UF_STREET }} {{ address.UF_HOME }}
              <i
                class="i-edit"
                v-if="$parent.isEditProject && isEditContacts"
                @click="editAddress(index)"
              ></i>

              <a
                v-if="
                  getAddressType(address.UF_TYPE_ADDR_ID) ===
                    'Фактический адрес' &&
                    getFactAddress().length > 1 &&
                    index !== 1
                "
                @click="deleteFactAddress(address.ID, index)"
                class="link-delete-row"
              ></a>
            </div>
          </div>
        </div>
      </div>

      <div
        class="org-box content-mb-42 screenplay-container"
        :class="[project.BLOCK_ORG_CONTACT_FACE ? 'active' : '']"
        id="screenplay-etap-1-8"
        ref="BLOCK_ORG_CONTACT_FACE"
      >
        <FirstScenariosStep
          :project="project"
          step-name="BLOCK_ORG_CONTACT_FACE"
          custom-class="stl-lt-box"
        />
        <div class="org-box-title clearfix">
          <span v-if="$parent.getProgramCode() !== 'lizing'"
            >Контактные лица по заявке на заем</span
          >
          <span v-else>Контактные лица лизингополучателя</span>
          <i
            class="i-plus"
            @click="makeContact('CONTACTS')"
            v-show="false"
            v-if="$parent.isEditProject && isEditContacts"
          ></i>
          <div class="pull-right" v-if="stConf.IS_DOWNLOAD_TRUST">
            <a class="link-shablon" @click="getShablonTrust"
              >Шаблон доверенности</a
            >
          </div>
        </div>
        <div class="table-responsive">
          <table class="table contacts-box-body">
            <thead>
              <tr>
                <th style="width:1%;"></th>
                <th style="width:30%;">ФИО</th>
                <th style="width:20%;">ТЕЛЕФОН</th>
                <th style="width:20%;">EMAIL</th>
                <th style="width:25%;">Должность</th>
                <!--<th style="width:15%;" class="text-center">
                  Доверенность на подпись с ЭЦП
                </th>
                <th style="width:20%;"></th>
                <th style="width:14%;">Срок действия доверенности</th>
                <th></th>-->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(contact, index) in project.CONTACTS">
                <td>
                  <i
                    class="i-edit"
                    @click="editContact('CONTACTS', index)"
                    v-show="false"
                    v-if="$parent.isEditProject && isEditContacts"
                  ></i>
                </td>
                <td>
                  <p>
                    {{ contact.UF_FIRST_NAME }} {{ contact.UF_NAME }}
                    {{ contact.UF_SECOND_NAME }}
                  </p>
                </td>
                <td>
                  <p>{{ contact.UF_PHONE1 }}</p>
                  <p>{{ contact.UF_PHONE2 }}</p>
                </td>
                <td>
                  <p>{{ contact.UF_EMAIL1 }}</p>
                  <p>{{ contact.UF_EMAIL2 }}</p>
                </td>
                <td>{{ contact.UF_POSITION }}</td>
                <!--<td
                  class="text-center"
                  v-if="currentUser.TYPE_USER === 'declarer'"
                >
                  <button
                    class="btn-download"
                    type="button"
                    @click="uploadContactDoc(contact.ID)"
                    v-if="
                      $parent.isEditProject &&
                        isEditContacts &&
                        stConf.IS_DOWNLOAD_TRUST
                    "
                  >
                    Загрузить
                  </button>
                </td>
                <td v-else-if="contact.UF_TRUST_FILE && acceptAvailable">
                  <label
                    class="radio-inline"
                    style="text-align: right;width: 40px"
                  >
                    <input
                      type="radio"
                      @change="updateContactAccept(index, 1)"
                      value="1"
                      :checked="contact.UF_TRUST_IS_ACCEPT === 1"
                    />
                    <span>да</span>
                  </label>
                  <label class="radio-inline" style="width: 20px">
                    <input
                      type="radio"
                      @change="updateContactAccept(index, 2)"
                      value="2"
                      :checked="contact.UF_TRUST_IS_ACCEPT === 2"
                    />
                    <span>нет</span>
                  </label>
                </td>
                <td v-else></td>
                <td>
                  <a
                    class="link-shablon"
                    v-if="contact.UF_TRUST_FILE"
                    :href="contact.UF_TRUST_FILE"
                    >{{ contact.UF_TRUST_FILE_NAME }}</a
                  >
                </td>
                <td class="dover-statys">{{ contact.UF_TRUST_DATE_END }}</td>
                <td class="dover-statys">
                  <p>
                    <span
                      v-tooltip="{
                        content: contact.UF_TRUST_MNG_NAME,
                        classes: 'message'
                      }"
                      :title="contact.UF_TRUST_MNG_NAME"
                      v-if="contact.UF_TRUST_IS_ACCEPT === 1"
                      >Принята</span
                    >
                    <span
                      v-tooltip="{
                        content: contact.UF_TRUST_MNG_NAME,
                        classes: 'message'
                      }"
                      v-if="contact.UF_TRUST_IS_ACCEPT === 2"
                      >Не принята</span
                    >
                  </p>
                </td>-->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--   конец блока подсказок   -->

      <div
        class="org-box content-mb-42"
        v-if="
          $parent.getProgramCode() === 'regfond' ||
            $parent.getProgramCode() === 'forestry_projects_rfrp' ||
            $parent.getProgramCode() === 'working_rfrp' ||
            $parent.getProgramCode() === 'complectyushie_rfrp'
        "
      >
        <div class="org-box-title clearfix">
          Контактные данные регионального фонда
          <i
            class="i-plus"
            v-show="false"
            @click="makeContact('CONTACTS_REGION_FOND')"
            v-if="isEditContactsRfpr"
          ></i>
        </div>
        <div class="table-responsive">
          <table class="table contacts-box-body">
            <thead>
              <tr>
                <th style="width:1%;"></th>
                <th style="width:15%;">ФИО</th>
                <th style="width:10%;">ТЕЛЕФОН</th>
                <th style="width:25%;">EMAIL</th>
                <th style="width:25%;">Должность</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(contact, index) in project.CONTACTS_REGION_FOND">
                <td>
                  <i
                    class="i-edit"
                    v-show="false"
                    @click="editContact('CONTACTS_REGION_FOND', index)"
                    v-if="isEditContactsRfpr"
                  ></i>
                </td>
                <td>
                  <p>
                    {{ contact.UF_FIRST_NAME }} {{ contact.UF_NAME }}
                    {{ contact.UF_SECOND_NAME }}
                  </p>
                </td>
                <td>
                  <p>{{ contact.UF_PHONE1 }}</p>
                  <p>{{ contact.UF_PHONE2 }}</p>
                </td>
                <td>
                  <p>{{ contact.UF_EMAIL1 }}</p>
                  <p>{{ contact.UF_EMAIL2 }}</p>
                </td>
                <td>
                  <p>{{ contact.UF_POSITION }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="org-box content-mb-42"
        v-if="$parent.getProgramCode() === 'lizing'"
      >
        <div class="org-box-title clearfix">
          Контактные лица лизинговой компании {{ project.ORG_LISING.UF_NAME }}
          <i
            class="i-plus"
            v-if="currentUser.ACTIVE_ROLE_CODE === 'lizing'"
            @click="makeContact('CONTACTS_LIZING')"
          ></i>
        </div>
        <div class="table-responsive">
          <table class="table contacts-box-body">
            <thead>
              <tr>
                <th style="width:1%;"></th>
                <th style="width:30%;">ФИО</th>
                <th style="width:20%;">ТЕЛЕФОН</th>
                <th style="width:20%;">EMAIL</th>
                <th style="width:25%;">Должность</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(contact, index) in project.CONTACTS_LIZING">
                <td>
                  <i
                    class="i-edit"
                    v-show="false"
                    v-if="currentUser.ACTIVE_ROLE_CODE === 'lizing'"
                    @click="editContact('CONTACTS_LIZING', index)"
                  ></i>
                </td>
                <td>
                  <p>
                    {{ contact.UF_FIRST_NAME }} {{ contact.UF_NAME }}
                    {{ contact.UF_SECOND_NAME }}
                  </p>
                </td>
                <td>
                  <p>{{ contact.UF_PHONE1 }}</p>
                  <p>{{ contact.UF_PHONE2 }}</p>
                </td>
                <td>
                  <p>{{ contact.UF_EMAIL1 }}</p>
                  <p>{{ contact.UF_EMAIL2 }}</p>
                </td>
                <td>
                  <p>{{ contact.UF_POSITION }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="modal fade in"
        v-show="showEditContact"
        :class="{
          show: showEditContact
        }"
        tabindex="-1"
        role="dialog"
      >
        <div class="add-contacts">
          <h3>{{ titleContactChange }}</h3>
          <div class="alert alert-danger" v-if="contactTextError">
            {{ contactTextError }}
          </div>
          <form action="#" class="add-contacts-form">
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_FIRST_NAME')
              }"
            >
              <label for="i-fam">Фамилия*</label>
              <input
                type="text"
                id="i-fam"
                v-model="contact.UF_FIRST_NAME"
                placeholder="Фамилия"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_FIRST_NAME") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_NAME')
              }"
            >
              <label for="i-name">Имя*</label>
              <input
                type="text"
                id="i-name"
                v-model="contact.UF_NAME"
                placeholder="Имя"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_NAME") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_SECOND_NAME')
              }"
            >
              <label for="i-lastname">Отчество</label>
              <input
                type="text"
                id="i-lastname"
                v-model="contact.UF_SECOND_NAME"
                placeholder="Отчество"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_SECOND_NAME") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_POSITION')
              }"
            >
              <label for="i-dol">Должность*</label>
              <input
                type="text"
                id="i-dol"
                v-model="contact.UF_POSITION"
                placeholder="Должность"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_POSITION") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_EMAIL1')
              }"
            >
              <label for="i-email-1">Email 1*</label>
              <input
                ref="aemailfield"
                type="text"
                id="i-email-1"
                v-model="contact.UF_EMAIL1"
                placeholder="Email (обязательно)"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_EMAIL1") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_EMAIL2')
              }"
            >
              <label for="i-email-2">Email 2</label>
              <input
                ref="bemailfield"
                type="text"
                id="i-email-2"
                v-model="contact.UF_EMAIL2"
                placeholder="Email"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_EMAIL2") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_PHONE1')
              }"
            >
              <label for="i-tell-1">Телефон 1*</label>
              <input
                type="text"
                id="i-tell-1"
                ref="aphonefield"
                v-model="contact.UF_PHONE1"
                placeholder="Телефон"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_PHONE1") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkContactErrorField('UF_PHONE2')
              }"
            >
              <label for="i-tell-2">Телефон 2</label>
              <input
                type="text"
                id="i-tell-2"
                ref="bphonefield"
                v-model="contact.UF_PHONE2"
                placeholder="Телефон"
              />
              <div class="error-text" style="padding-left: 50%">
                {{ checkContactErrorField("UF_PHONE2") }}
              </div>
            </div>
          </form>
          <div class="text-center box-btn">
            <button
              class="btn-dell"
              v-if="contactIndex !== -1"
              type="button"
              @click="deleteContact(contact.ID, contactIndex)"
            >
              Удалить
            </button>
            <button class="btn-save" type="button" @click="saveContact()">
              Сохранить
            </button>
            <button
              class="btn-close"
              type="button"
              @click="showEditContact = false"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>

      <div
        class="modal fade in show"
        v-if="showSnilsUploader"
        tabindex="-1"
        role="dialog"
      >
        <div class="download-snails clearfix">
          <h3>Загрузка СНИЛС Руковолителя</h3>
          <form action="#" class="f-d-snails">
            <label class="window-file">
              <vue-dropzone
                ref="snilsDR"
                class="window-area-file"
                id="snils-dropzone"
                :options="{
                  autoProcessQueue: false,
                  autoQueue: false,
                  accept: snilsChange,
                  url: 'x',
                  maxFiles: 1,
                  maxFilesize: 25,
                  dictFileTooBig:
                    'Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб',
                  uploadMultiple: false,
                  dictDefaultMessage:
                    'Выберите или перетащите сюда файл (максимум 25 Мб)'
                }"
              ></vue-dropzone>
              <div class="error-text">{{ addFileSnilsError }}</div>
              <div class="text-right">
                <button
                  class="btn-download"
                  :disabled="snilsFileName === ''"
                  type="button"
                  @click="uploadSnils"
                >
                  Загрузить
                </button>
              </div>
            </label>
            <div class="error-text">{{ snilsFileError }}</div>
            <p>
              Загруженный файл не будет отображен. Факт сохранения СНИЛС вы
              увидите напротив кнопки "Загрузить". Информация будет внесена в
              течение дня.
            </p>
            <div class="text-center">
              <button
                class="btn-close"
                type="button"
                @click="showSnilsUploader = false"
              >
                Отмена
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        class="modal fade in show"
        v-if="showSiteDialog"
        tabindex="-1"
        role="dialog"
      >
        <div class="add-adress" style="width: 300px">
          <h3>Укажите сайт</h3>
          <form
            action="#"
            class="add-adress-form"
            style="height: auto;overflow-y: hidden;"
          >
            <div>
              <label for="i-pi-site">Сайт</label>
              <input
                type="text"
                id="i-pi-site"
                v-model="site"
                placeholder="Сайт"
              />
            </div>
          </form>
          <div class="text-center box-btn">
            <button class="btn-save" type="button" @click="updateSite()">
              Изменить
            </button>
            <button
              class="btn-close"
              type="button"
              @click="showSiteDialog = false"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>

      <div
        class="modal fade in show"
        v-if="showAdressTypeDialog"
        tabindex="-1"
        role="dialog"
      >
        <div class="add-adress" style="width: auto">
          <h3>Укажите тип адреса</h3>
          <form
            action="#"
            class="add-adress-form"
            style="height: auto;overflow-y: hidden;"
          >
            <div>
              <label for="i-type-address">Тип адреса</label>
              <select v-model="address.UF_TYPE_ADDR_ID" id="i-type-address">
                <option
                  v-for="item in aAddress()"
                  v-bind:value="item.ID"
                  v-bind:key="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>
          </form>
          <div class="text-center box-btn">
            <button
              class="btn-save"
              :disabled="address.UF_TYPE_ADDR_ID == 0"
              type="button"
              @click="makeAddress(address.UF_TYPE_ADDR_ID)"
            >
              Добавить
            </button>
            <button
              class="btn-close"
              type="button"
              @click="showAdressTypeDialog = false"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
      <div
        class="modal fade in show"
        v-if="showAdressDialog"
        tabindex="-1"
        role="dialog"
      >
        <div class="add-adress">
          <h3>Адрес организации</h3>
          <h4>Добавление адреса</h4>
          <form action="#" class="add-adress-form">
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_POST_INDEX')
              }"
            >
              <label for="i-pi">Почтовый индекс</label>
              <input
                type="text"
                id="i-pi"
                v-model="address.UF_POST_INDEX"
                placeholder="Почтовый индекс"
              />
              <div class="error-text">
                {{ checkAddressErrorField("UF_POST_INDEX") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_REGION_ID')
              }"
            >
              <label for="i-reg">Регион</label>
              <select v-model="address.UF_REGION_ID" id="i-reg">
                <option
                  v-for="item in directory.regions"
                  v-bind:value="item.ID"
                  v-bind:key="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
              <div class="error-text">
                {{ checkAddressErrorField("UF_REGION_ID") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_CITY')
              }"
            >
              <label for="i-np">Населенный пункт</label>
              <input
                type="text"
                id="i-np"
                v-model="address.UF_CITY"
                placeholder="Населенный пункт"
              />
              <div class="error-text">
                {{ checkAddressErrorField("UF_CITY") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_STREET')
              }"
            >
              <label for="i-str">Улица</label>
              <input
                type="text"
                id="i-str"
                v-model="address.UF_STREET"
                placeholder="Улица"
              />
              <div class="error-text">
                {{ checkAddressErrorField("UF_STREET") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_HOME')
              }"
            >
              <label for="i-dks">Дом, корпус, строение</label>
              <input
                type="text"
                id="i-dks"
                v-model="address.UF_HOME"
                placeholder="Дом, корпус, строение"
              />
              <div class="error-text">
                {{ checkAddressErrorField("UF_HOME") }}
              </div>
            </div>
            <div
              v-bind:class="{
                'has-error': checkAddressErrorField('UF_OFFICE_NUMBER')
              }"
            >
              <label for="i-noffice">Номер офиса</label>
              <input
                type="text"
                id="i-noffice"
                v-model="address.UF_OFFICE_NUMBER"
                placeholder="Номер офиса"
              />
              <div class="error-text">
                {{ checkAddressErrorField("UF_OFFICE_NUMBER") }}
              </div>
            </div>
          </form>
          <div class="text-center box-btn">
            <button class="btn-save" type="button" @click="saveAddress()">
              Сохранить
            </button>
            <button
              class="btn-close"
              type="button"
              @click="showAdressDialog = false"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>

      <div
        class="modal fade in show"
        v-if="showDocContactUploader"
        tabindex="-1"
        role="dialog"
      >
        <div class="download-doverennost">
          <h3>Загрузка доверенности</h3>
          <form action="#" class="download-doverennost-form">
            <label class="window-file">
              <vue-dropzone
                ref="docDR"
                class="window-area-file"
                id="doc-dropzone"
                :options="{
                  autoProcessQueue: false,
                  autoQueue: false,
                  accept: docChange,
                  url: 'x',
                  maxFiles: 1,
                  uploadMultiple: false,
                  maxFilesize: 25,
                  dictFileTooBig:
                    'Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб',
                  dictDefaultMessage:
                    'Выберите или перетащите сюда файл (максимум 25 Мб)'
                }"
              ></vue-dropzone>
              <div class="error-text">
                {{ addFileDocError }}
                {{ checkContactDocErrorField("UF_TRUST_FILE") }}
              </div>
            </label>
            <div>
              <label>
                Срок действия доверенности
                <span style="color:red;">*</span>
              </label>
              <datepicker
                v-model="contactDoc.UF_TRUST_DATE_END"
                :language="ru"
                :format="dateFormat"
              ></datepicker>
              <div class="error-text">
                {{ checkContactDocErrorField("UF_TRUST_DATE_END") }}
              </div>
            </div>
            <div>
              <label for="i-spodpisanta">
                СНИСЛ подписанта
                <span style="color:red;">*</span>
              </label>
              <input
                type="text"
                id="i-spodpisanta"
                placeholder="СНИСЛ подписанта"
                v-model="contactDoc.UF_SNILS"
              />
              <div class="error-text">
                {{ checkContactDocErrorField("UF_SNILS") }}
              </div>
            </div>
          </form>
          <div class="text-center box-btn">
            <i class="i-no-i"></i>
            <button
              class="btn-download"
              :disabled="docName === ''"
              type="button"
              @click="uploadDoc"
            >
              Загрузить
            </button>
            <button
              class="btn-close"
              type="button"
              @click="showDocContactUploader = false"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="width: 250px">
        <div class="alert alert-danger" v-for="err in lizingErrors">
          {{ err.TEXT }}
        </div>
        <div class="form-group">
          <label>Название организации</label>
          <input
            v-model="lizing.UF_NAME"
            class="form-control"
            placeholder="Название оганизации"
          />
        </div>
        <div class="form-group">
          <label>ОГРН</label>
          <input
            v-model="lizing.UF_OGRN"
            class="form-control"
            placeholder="ОГРН организации"
          />
        </div>
        <button type="button" @click="addOrgLizing" class="btn btn-default">
          Добавить организацию
        </button>
      </div>
    </div>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import Inputmask from "inputmask";
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORIES,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import Contacts from "./lists/contacts";
import { ProjectsService } from "@/common/api.service";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ru } from "vuejs-datepicker/dist/locale";
import vueDropzone from "vue2-dropzone";
import { AUTH_URL } from "@/common/config";
import FirstScenariosStep from "@/components/project/form/subpartial/FirstScenariosStep.vue";

export default {
  name: "step100",
  components: {
    FirstScenariosStep,
    Contacts,
    vueDropzone,
    Datepicker
  },
  props: ["step"],
  data() {
    return {
      titleContactChange: "Создание контакта",
      lizing: {
        UF_NAME: "",
        UF_OGRN: ""
      },
      lizingErrors: [],
      contactTextError: "",
      isEditContacts: false,
      isEditContactsRfpr: false,
      addFileDocError: "",
      addFileSnilsError: "",
      showSnilsUploader: false,
      snilsFile: "",
      snilsFileName: "",
      snilsFileError: "",
      showAdressDialog: false,
      showAdressTypeDialog: false,
      addressIndex: 0,
      showSiteDialog: false,
      showEditContact: false,
      site: "",
      address: {
        ID: 0,
        UF_CITY: "",
        UF_COMPANY_ID: 0,
        UF_HOME: 0,
        UF_OFFICE_NUMBER: 0,
        UF_POST_INDEX: 0,
        UF_REGION_ID: 0,
        UF_STREET: "",
        UF_TYPE_ADDR_ID: 0
      },
      addressErrors: [],
      contact: {},
      contactIndex: 0,
      contactErrors: [],
      contactTp: "CONTACTS",
      showDocContactUploader: false,
      docName: "",
      docId: 0,
      contactDoc: {
        UF_TRUST_FILE: "",
        UF_TRUST_DATE_END: "",
        UF_SNILS: ""
      },
      stConf: {},
      contactDocErrors: [],
      snilsErrors: [],
      acceptAvailable: false,
      ru: ru
    };
  },

  mounted() {
    this.isEditContacts = this.currentUser.ACTIVE_ROLE_CODE !== "manager3";
    if (this.currentUser.ACTIVE_ROLE_CODE === "region_fond") {
      this.isEditContactsRfpr = true;
    }
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "regions",
      "org_form",
      "type_address"
    ]);

    ProjectsService.getRulesChangeStatusUser(this.project.UF_STATUS_ID).then(
      ({ data }) => {
        this.stConf = data;
      },
      this
    );
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      if (data.IS_ACCEPT_TRUST) {
        this.acceptAvailable = true;
      }
    }, this);
  },

  computed: {
    regYears() {
      let dt = new Date();
      let years = [];
      for (let i = dt.getFullYear(); i >= 1991; i--) {
        years.push(i);
      }
      return years;
    },

    ...mapGetters(["directory", "currentUser", "project"])
  },

  methods: {
    addOrgLizing() {
      this.lizingErrors = [];
      ProjectsService.addOrgLizing(this.project.ID, this.lizing).then(
        ({ data }) => {
          if (data.error) {
            this.lizingErrors = data.errorAr;
            return;
          }
          this.project.ORG_INFO = data.ORG_INFO;
        },
        this
      );
    },

    getShablonTrust() {
      ProjectsService.getShablonTrust().then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },

    updateContactAccept(index, ac) {
      ProjectsService.saveAcceptContact(
        this.$parent.project.ID,
        this.project.CONTACTS[index].ID,
        {
          UF_TRUST_IS_ACCEPT: ac
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        }
        this.project.CONTACTS[index].UF_TRUST_IS_ACCEPT = ac;
      }, this);
    },

    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },

    aAddress() {
      let types = [];
      this.directory.type_address.forEach(function(a) {
        let add = true;
        if (this.project.ORG_INFO.ADDRESS) {
          this.project.ORG_INFO.ADDRESS.forEach(function(v) {
            if (v.UF_TYPE_ADDR_ID === a.ID && a.CODE !== "fact_address") {
              add = false;
            }
          });
        }
        if (add) {
          types.push(a);
        }
      }, this);
      return types;
    },

    getFactAddress() {
      let i = [];
      this.project.ORG_INFO.ADDRESS.forEach(v => {
        if (v.UF_TYPE_ADDR_ID === 7370937) {
          i.push(v.UF_TYPE_ADDR_ID);
        }
      }, this);
      return i;
    },

    getAddressType(id) {
      let t = this.directory.type_address.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },

    getRegion(id) {
      let t = this.directory.regions.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },

    deleteFactAddress(idAddress, index) {
      if (confirm("Вы уверены, что хотите удалить адрес?")) {
        ProjectsService.deleteAddress(this.project.ORG_INFO.ID, idAddress).then(
          ({ data }) => {
            if (data.error) {
              this.addressErrors = data.errorAr;
            }
            this.project.ORG_INFO.ADDRESS.splice(index, 1);
          },
          this
        );
      }
    },

    editAddress(index) {
      this.addressErrors = [];
      this.addressIndex = index;
      this.address = JSON.parse(
        JSON.stringify(this.project.ORG_INFO.ADDRESS[this.addressIndex])
      );
      this.showAdressDialog = true;
    },

    saveAddress() {
      if (!this.project.ORG_INFO.ADDRESS) {
        this.project.ORG_INFO.ADDRESS = [];
      }
      if (this.addressIndex !== -1) {
        ProjectsService.editAddress(
          this.project.ORG_INFO.ID,
          this.address.UF_TYPE_ADDR_ID,
          this.address
        )
          .then(({ data }) => {
            if (data.error) {
              this.addressErrors = data.errorAr;
              return;
            }
            this.showAdressDialog = false;
            this.project.ORG_INFO.ADDRESS[this.addressIndex] = JSON.parse(
              JSON.stringify(this.address)
            );
          }, this)
          .catch(data => {
            console.log(data);
          });
      } else {
        ProjectsService.addAddress(
          this.project.ORG_INFO.ID,
          this.address.UF_TYPE_ADDR_ID,
          this.address
        ).then(({ data }) => {
          if (data.error) {
            this.addressErrors = data.errorAr;
            return;
          }
          this.address.ID = data.ID;
          this.address;
          this.showAdressDialog = false;
          this.project.ORG_INFO.ADDRESS.push(
            JSON.parse(JSON.stringify(this.address))
          );
        }, this);
      }
      // this.getFactAddress();
    },

    makeAddress(type) {
      this.showAdressTypeDialog = false;
      this.addressErrors = [];
      this.addressIndex = -1;
      this.address = {
        UF_CITY: "",
        UF_COMPANY_ID: 0,
        UF_HOME: "",
        UF_OFFICE_NUMBER: "",
        UF_POST_INDEX: "",
        UF_REGION_ID: 0,
        UF_STREET: "",
        UF_TYPE_ADDR_ID: type
      };
      this.showAdressDialog = true;
      this.getFactAddress();
    },

    makeContact(tp) {
      this.contactTp = tp;
      this.contactIndex = -1;
      this.contact = {
        ID: 0,
        UF_COMPANY_ID: this.project.ORG_INFO.ID,
        UF_EMAIL1: "",
        UF_EMAIL2: "",
        UF_FIRST_NAME: "",
        UF_IS_LIZING_ADD: 0,
        UF_IS_LIZING_CONTACT: 0,
        UF_IS_REG_F_CONTACT: 0,
        UF_NAME: "",
        UF_PHONE1: "",
        UF_PHONE2: "",
        UF_POSITION: "",
        UF_PROJECT_ID: this.project.ID,
        UF_SECOND_NAME: "",
        UF_SNILS: null,
        UF_TRUST_DATE_ACEPT: null,
        UF_TRUST_DATE_END: null,
        UF_TRUST_FILE: null,
        UF_TRUST_IS_ACCEPT: null
      };
      this.showEditContact = true;
      this.contactTextError = "";
      this.titleContactChange = "Создание контакта ";
      this.contactMask();
    },

    contactMask() {
      var im = new Inputmask({
        mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
        greedy: false,
        onBeforePaste: function(pastedValue) {
          pastedValue = pastedValue.toLowerCase();
          return pastedValue.replace("mailto:", "");
        },
        definitions: {
          "*": {
            validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
            casing: "lower"
          }
        }
      });
      im.mask(this.$refs.aemailfield);
      im.mask(this.$refs.bemailfield);

      var phonemask = new Inputmask({
        mask: "+7 (999) 999-99-99",
        greedy: false,
        definitions: {
          "*": {
            validator: "[0-9-]",
            casing: "lower"
          }
        }
      });
      phonemask.mask(this.$refs.aphonefield);
      phonemask.mask(this.$refs.bphonefield);
    },

    saveContact() {
      if (!this.project[this.contactTp]) {
        this.project[this.contactTp] = [];
      }
      if (this.contactTp === "CONTACTS_LIZING") {
        this.contact["UF_IS_LIZING_CONTACT"] = 1;
      } else {
        this.contact["UF_IS_LIZING_CONTACT"] = 0;
      }
      this.contactTextError = "";
      if (this.contactIndex !== -1) {
        ProjectsService.editContacts(
          this.project.ORG_INFO.ID,
          this.$parent.project.ID,
          this.contact
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              return;
            }
            this.showEditContact = false;
            this.project[this.contactTp][this.contactIndex] = JSON.parse(
              JSON.stringify(this.contact)
            );
          }, this)
          .catch(({ data }) => {
            if (data["text-error"]) {
              this.contactTextError = data["text-error"];
            }
          }, this);
      } else {
        ProjectsService.addContacts(
          this.project.ORG_INFO.ID,
          this.$parent.project.ID,
          this.contact
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              if (data["text-error"]) {
                this.contactTextError = data["text-error"];
              }
              return;
            }
            this.contact.ID = data.ID;
            this.showEditContact = false;
            this.project[this.contactTp].push(
              JSON.parse(JSON.stringify(this.contact))
            );
          }, this)
          .catch(({ data }) => {
            if (data["text-error"]) {
              this.contactTextError = data["text-error"];
            }
          }, this);
      }
    },

    deleteContact(contactId, contactIndex) {
      console.log(contactId);
      if (confirm("Вы уверены, что хотите удалить контакт?")) {
        ProjectsService.deleteContacts(
          this.project.ORG_INFO.ID,
          this.$parent.project.ID,
          contactId
        )
          .then(({ data }) => {
            if (data.error) {
              this.contactErrors = data.errorAr;
              return;
            }

            this.project[this.contactTp].splice(contactIndex, 1);
            this.showEditContact = false;
          }, this)
          .catch(err => console.log("deleteContactError: ", err.message));
      }
      this.showEditContact = false;
    },

    editContact(tp, index) {
      this.contactErrors = [];
      this.contactIndex = index;
      this.contactTp = tp;
      this.contact = JSON.parse(
        JSON.stringify(this.project[this.contactTp][this.contactIndex])
      );
      this.showEditContact = true;
      this.titleContactChange = "Редактирование контакта";
      this.contactMask();
    },

    createAddress() {
      this.showAdressTypeDialog = true;
    },

    uploadSnils() {
      ProjectsService.downloadFileSnils(this.project.ORG_INFO.ID, {
        UF_SNILS_FILE: this.snilsFile
      })
        .then(({ data }) => {
          if (data.error) {
            this.snilsErrors = data.errorAr;
            return;
          }
          this.$parent.fetchProject();
          this.showSnilsUploader = false;
        }, this)
        .catch(data => {
          console.log(data);
        });
    },

    uploadDoc() {
      ProjectsService.downloadFileSnilsContact(
        this.project.ORG_INFO.ID,
        this.docId,
        this.contactDoc
      )
        .then(({ data }) => {
          if (data.error) {
            this.contactDocErrors = data.errorAr;
            return;
          }
          this.$parent.fetchProject();
          this.showDocContactUploader = false;
        }, this)
        .catch(data => {
          console.log(data);
        });
    },

    snilsChange(file) {
      let f = this.$refs.snilsDR.dropzone.files;
      if (f.length > 1) {
        this.$refs.snilsDR.removeFile(f[0]);
      }
      this.snilsFileName = file.name;
      let reader = new FileReader();
      this.addFileSnilsError = "";
      reader.addEventListener("loadend", function() {});
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (file.size < 1024 * 1024 * 25) {
          this.snilsFileName = file.name;
          this.snilsFile = reader.result;
        } else {
          this.snilsFileName = "";
          this.snilsFile = "";
          this.addFileSnilsError =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };
    },

    docChange(file) {
      let f = this.$refs.docDR.dropzone.files;
      if (f.length > 1) {
        this.$refs.docDR.removeFile(f[0]);
      }
      this.docName = file.name;
      let reader = new FileReader();
      this.addFileDocError = "";
      reader.addEventListener("loadend", function() {});
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (file.size < 1024 * 1024 * 25) {
          this.docName = file.name;
          this.contactDoc.UF_TRUST_FILE = reader.result;
        } else {
          this.docName = "";
          this.contactDoc.UF_TRUST_FILE = "";
          this.addFileDocError =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };
    },

    checkAddressErrorField(field) {
      let t = this.addressErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },

    checkContactErrorField(field) {
      let t = this.contactErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },

    checkContactDocErrorField(field) {
      let t = this.contactDocErrors.filter(c => c.FIELDS === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },

    makeSiteDialog() {
      this.site = this.project.ORG_INFO.UF_WEB_SITE;
      this.showSiteDialog = true;
    },

    updateSite() {
      ProjectsService.editWebSite(this.project.ORG_INFO.ID, {
        UF_WEB_SITE: this.site
      })
        .then(({ data }) => {
          if (data.error) {
            return;
          }
          this.showSiteDialog = false;
          this.project.ORG_INFO.UF_WEB_SITE = this.site;
        }, this)
        .catch(data => {
          console.log(data);
        });
    },

    uploadContactDoc(id) {
      this.docId = id;
      this.docName = "";
      this.contactDocErrors = [];
      this.contactDoc = {
        UF_TRUST_FILE: "",
        UF_TRUST_DATE_END: "",
        UF_SNILS: ""
      };
      this.showDocContactUploader = true;
    }
  }
};
</script>

<style scoped></style>
